import { Cubit } from "blac-next";
import { historyState } from "../state";
import { brioche, SwipeDirection } from "@9amhealth/shared";

type BriocheDismisserCubitState = object;

interface NavigateSubscription {
  unsubscribe: () => void;
}

export class BriocheDismisserCubit extends Cubit<BriocheDismisserCubitState> {
  private subscriptionNavigate: NavigateSubscription | null = null;

  /**
   * Dismisses the active Brioche on any navigation event.
   */
  public readonly activateOnNavigate = () => {
    this.subscriptionNavigate = historyState.subscribe({
      next: () => brioche.dismiss()
    });
  };

  /**
   * Deactivates the dismiss actions on navigation events
   */
  public readonly deActivateOnNavigate = () => {
    this.subscriptionNavigate?.unsubscribe();
  };

  public readonly activate = () => {
    this.activateOnNavigate();
  };

  public readonly deActivate = () => {
    this.deActivateOnNavigate();
  };

  public readonly dismissManually = (direction?: SwipeDirection) => {
    brioche.dismiss(direction);
  };
}
